import styled, { css } from 'styled-components';

const disabled = css`
  background: #f1f1f0;
  color: ${(props) => props.theme.colors.grey6};
`;

const StyledInput = styled('input')<any>`
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 13px 0 13px 16px;
  font-size: 16px;
  border: none;
  overflow-y: hidden;
  overflow-x: auto;

  color: ${(props) =>
    props?.isPlaceholder ? props.theme.colors.grey3 : props.theme.colors.grey7};

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.grey5};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-calendar-picker-indicator {
    display: block;
    width: 18px;
    margin: 0 16px;
    margin-bottom: -6px;
  }

  &.error {
    &::-webkit-calendar-picker-indicator {
      margin-right: 32px;
    }
  }

  ${(props) => props.disabled && disabled}

  ${(props) =>
    props.iconPosition !== 'end' && props.icon
      ? css`
          padding: 13px 16px 13px 0;
        `
      : null}
`;

export default StyledInput;
